/*
 * Module for the Benefit Payroll Withholding Register criteria page
 */
rs.module("content/reports/criteria/benefitpayrollwithholdingregistercriteria",

    ["controls/data/grid"],

    function (gridModule) {

        function initialize(lrsGridApi, jsSelectors, ajaxUrls, compositeMonthYearColumnID) {
            var filter = $.js(jsSelectors.filter);
            var includeManualCheckBox = filter.js(jsSelectors.includeManualCheckBox);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // register checkbox change event
            includeManualCheckBox.change(includeManualChanged);

            // refresh the grid based on checkbox selection
            function includeManualChanged() {
                loadingSpinner.show();
                gridModule.update(
                    ajaxUrls.refreshGridUrl,

                    { includeManualPayroll: includeManualCheckBox.is(':checked') },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }

            var payrollProcessingMonthYearHidden = $.js(jsSelectors.payrollProcessingMonthYearHidden);

            // populate the hidden field with the Payroll Period of the selected row
            lrsGridApi.selectionChanged(function (values, rows) {
                if (values.length > 0) {
                    var compositeMonthYear = rows[0][compositeMonthYearColumnID];
                    payrollProcessingMonthYearHidden.val(compositeMonthYear);
                } else {
                    payrollProcessingMonthYearHidden.val('');
                }
            });
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);